export default {
    backend_url: process.env.REACT_APP_BACKEND_URL
}